"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13 .3a.7.7 0 0 1 .7.7v1.3H15a.7.7 0 0 1 0 1.4h-1.3V5a.7.7 0 1 1-1.4 0V3.7H11a.7.7 0 1 1 0-1.4h1.3V1a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.999 6.875v2.688a2.7 2.7 0 0 1-2.7 2.7H8.362a.3.3 0 0 0-.193.07l-1.298 1.084c-.941.786-2.371.117-2.371-1.109a.045.045 0 0 0-.045-.045h-.089A2.367 2.367 0 0 1 2 9.896V5.701a2.7 2.7 0 0 1 2.7-2.7H9c0 .492.09.964.253 1.4H4.699a1.3 1.3 0 0 0-1.3 1.3v4.195c0 .534.433.967.967.967h.089a1.445 1.445 0 0 1 1.447 1.463q0 .005.003.006.004.007.02.017a.1.1 0 0 0 .027.005l.006-.001.015-.01 1.299-1.085a1.7 1.7 0 0 1 1.09-.395h2.937a1.3 1.3 0 0 0 1.3-1.3V6.981a4 4 0 0 0 1.4-.106"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AddCommentIcon16.js.map